<template>
  <div class="caja__container">
    <v-row>
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row no-gutters>
                <v-col cols="10">
                  <span class="caja__titulo">Caja y movimientos</span>
                </v-col>
                <v-col>
                  <Clock />
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <CajaTopBox
                  v-for="box in topBoxes"
                  :key="box.tipo"
                  :cols="box.cols"
                  :color="box.color"
                  :type="box.tipo"
                  :content="box"
                  @box-click="topBoxClick"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="7">
        <v-card>
          <MovimientosCajaTbl 
            dataDescription="cobros"
            :items="cobros" 
            :headers="cobrosHeaders" 
            tableTitle="Pagos recibidos por servicios lavandería"
            searchPrompt="Buscar cobros"
            noDataWarn="Ningún cobro realizado hasta el momento."
          />
        </v-card>
      </v-col>
      <v-col cols="5">
        <v-card>
          <MovimientosCajaTbl
            dataDescription="entradas_y_salidas"
            :items="movimientos"
            :headers="movimientosHeaders"
            tableTitle="Entradas y Salidas de Efectivo"
            searchPrompt="Buscar movimientos"
            noDataWarn="No se han realizado movimientos aún."
          />
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal Caja -->
    <CajaModal @refresh-caja-content="getUIData"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

// const {getUltimoCorte, getCortesCount, getCobros, getMovimientos, getFondoCaja, getTotal} = api.services.cajaService;

import Clock from "../components/Clock";
import CajaTopBox from "../components/CashRegister/CajaTopBox";
import MovimientosCajaTbl from "../components/CashRegister/MovimientosCajaTbl";
import CajaModal from '../components/CashRegister/CajaModal';

export default {
  name: "Caja",
  components: {
    Clock,
    CajaTopBox,
    MovimientosCajaTbl,
    CajaModal,
  },
  data() {
    return {
      topBoxesData: [],
      ultimoCorte: null,
      corteCount: null,
      cobros: [],
      cobrosHeaders: [
        {
          text: "#",
          align: "left",
          sortable: true,
          value: "index",
        },
        {
          text: "Hora",
          align: "left",
          sortable: true,
          value: "fecha",
        },
        {
          text: "Folio",
          align: "left",
          sortable: true,
          value: "codigo",
        },
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "nombreCliente",
        },
        {
          text: "Precio",
          align: "left",
          sortable: true,
          value: "total",
        },
        {
          text: "Pago",
          align: "left",
          sortable: true,
          value: "monto",
        },
        {
          text: "Saldo",
          align: "left",
          sortable: true,
          value: "saldo",
        },
        { text: 'Más', value: 'data-table-expand' },
      ],
      movimientos: [],
      movimientosHeaders: [
        {
          text: "#",
          align: "left",
          sortable: true,
          value: "index",
        },
        {
          text: "Hora",
          align: "left",
          sortable: true,
          value: "fecha",
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "tipo",
        },
        {
          text: "Monto",
          align: "left",
          sortable: true,
          value: "monto",
        },
        {
          text: "Cajero",
          align: "left",
          sortable: true,
          value: "nombreUsuario",
        },
        { text: 'Más', value: 'data-table-expand' },
      ],
    };
  },
  computed: {
    topBoxes:{
      get: function(){ return this.topBoxesData},
      set: function(data){
        this.topBoxesData = data;
      }
    }
  },
  methods: {
    ...mapActions(['openCajaModal']),
    getUltimoCorte(){},
    getCortesCount(){},
    getCobros(){},
    getMovimientos(){},
    getFondoCaja(){},
    getTotal(){},
    topBoxClick(e) {
      this.openCajaModal(e);
    },
    getUIData() {
      // const today = DateTime.local().toISODate();
      const ultimoCorte = this.getUltimoCorte();
      const corteCount = this.getCortesCount();
      const cobros = this.getCobros();
      const movimientos = this.getMovimientos();
      const fondoCaja = this.getFondoCaja();
      const totalCobros = this.getTotal("cobro");
      const totalDepositos = this.getTotal("deposito");
      const totalRetiros = this.getTotal("retiro");
      
      this.cobros = cobros ? cobros : [];
      this.movimientos = movimientos ? movimientos : [];

      this.topBoxes = [
        {
          tipo: "corte",
          titulo: "Último Corte",
          count: corteCount ? corteCount.count : 0,
          monto:
            (ultimoCorte && ultimoCorte.monto)
              ? ultimoCorte.monto
              : "----",
          saldo:
            (ultimoCorte && ultimoCorte.saldo)
              ? ultimoCorte.saldo
              : 0.0,
          hora: (ultimoCorte && ultimoCorte.fecha) ? ultimoCorte.fecha.substr(11, 5) : "--",
          cols: 3,
          color: "purple",
          iconType: "mdi",
          icon: "mdi-currency-usd",
        },
        {
          tipo: "fondo",
          titulo: "Fondo Caja",
          monto: fondoCaja ? fondoCaja.monto : 0.0,
          hora: fondoCaja ? fondoCaja.fecha.substr(11, 5) : 0.0,
          cols: 3,
          color: "grey",
          iconType: "mdi",
          icon: "mdi-cash-register",
        },
        {
          tipo: "cobro",
          titulo: "Cobros",
          cantidad: (totalCobros && totalCobros.num) ? totalCobros.num : 0,
          monto: (totalCobros && totalCobros.total) ? totalCobros.total : 0.0,
          cols: 2,
          color: "cyan",
          iconType: "fa",
          icon: "hand-holding-usd",
        },
        {
          tipo: "entrada",
          titulo: "Entradas",
          cantidad:
            (totalDepositos && totalDepositos.num) ? totalDepositos.num : 0,
          monto:
            (totalDepositos && totalDepositos.total) ? totalDepositos.total : 0.0,
          cols: 2,
          color: "green",
          iconType: "mdi",
          icon: "mdi-arrow-down",
        },
        {
          tipo: "salida",
          titulo: "Salidas",
          cantidad: (totalRetiros && totalRetiros.num) ? totalRetiros.num : 0,
          monto: (totalRetiros && totalRetiros.total) ? totalRetiros.total : 0.0,
          cols: 2,
          color: "red",
          iconType: "mdi",
          icon: "mdi-arrow-up",
        },
      ];
    },
  },
  beforeMount() {
    this.getUIData();
  },
};
</script>

<style lang="scss" scoped>
.caja {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__titulo {
    font-size: 1.25rem;
    font-weight: 500;
  }
}
</style>